import React, { useEffect, useState } from "react";
import { Modal, Box, Typography, Button } from "@mui/material";
import { searchPaciente } from "../api/apiService";

const PacienteModal = ({ isOpen, onClose, cpf }) => {
  const [pacientesCache, setPacientesCache] = useState({});
  const [paciente, setPaciente] = useState(null);
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState(null);

  useEffect(() => {
    if (isOpen && cpf) {
      if (pacientesCache[cpf]) {
        setPaciente(pacientesCache[cpf]);
        setErro(null);
      } else {
        fetchPaciente(cpf);
      }
    }
  }, [isOpen, cpf, pacientesCache]);

  const fetchPaciente = async (cpf) => {
    if (!cpf || cpf === "undefined") return;

    setLoading(true);
    setErro(null);

    try {
      const data = await searchPaciente(cpf);
      setPaciente(data);

      setPacientesCache((prev) => ({
        ...prev,
        [cpf]: data || prev[cpf],
      }));
    } catch (error) {
      console.error("Erro ao buscar paciente:", error);
      setErro("Erro ao buscar paciente. CPF não encontrado.");
      setPaciente(null);
    } finally {
      setLoading(false);
    }
  };

  const formatarCampo = (valor, tipo) => {
    if (!valor) return "";

    switch (tipo) {
      case "cpf":
        return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
      case "data":
        return valor.split("-").reverse().join("/");
      case "telefone":
        return valor.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
      case "cep":
        return valor.replace(/(\d{5})(\d{3})/, "$1-$2");
      default:
        return valor;
    }
  };

  const handleClose = () => {
    // Apenas fecha o modal sem resetar nada
    onClose();
  };

  return (
    <Modal open={isOpen} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          width: 400,
        }}
      >
        {loading ? (
          <Typography>Carregando dados do paciente...</Typography>
        ) : erro ? (
          <Typography color="error">{erro}</Typography>
        ) : paciente ? (
          <>
            <Typography variant="h6">Dados do Paciente</Typography>
            <Typography>
              <strong>Nome:</strong> {paciente.nomeCompleto}
            </Typography>
            <Typography>
              <strong>CPF:</strong> {formatarCampo(paciente.cpf, "cpf")}
            </Typography>
            <Typography>
              <strong>Data de Nascimento:</strong>{" "}
              {formatarCampo(paciente.dataNascimento, "data")}
            </Typography>
            <Typography>
              <strong>Telefone:</strong>{" "}
              {formatarCampo(paciente.telefone, "telefone")}
            </Typography>
            <Typography>
              <strong>Email:</strong> {paciente.email}
            </Typography>
            <Typography variant="h6" sx={{ mt: 2 }}>
              Endereço
            </Typography>
            <Typography>
              {paciente.endereco}, {paciente.numero}, {paciente.complemento}
            </Typography>
            <Typography>
              {paciente.bairro}, {paciente.cidade} - {paciente.estado}
            </Typography>
            <Typography>
              <strong>CEP:</strong> {formatarCampo(paciente.cep, "cep")}
            </Typography>
            <Typography variant="h6" sx={{ mt: 2 }}>
              UBS
            </Typography>
            <Typography>{paciente.nomeUbs || "Não informado"}</Typography>
            <Button onClick={handleClose} sx={{ mt: 2 }}>
              Fechar
            </Button>
          </>
        ) : (
          <Typography color="error">Erro ao carregar paciente.</Typography>
        )}
      </Box>
    </Modal>
  );
};

export default PacienteModal;
